module.exports = __webpack_public_path__ + "img/menual02.7cea8fc9.svg";